'use client';

import { Container, Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';

interface StatItem {
  value: string;
  label: string;
  description?: string;
}

interface StatsGridBlockProps {
  items: StatItem[];
  title?: string;
}

const statSurfaceCycle = [
  'var(--surface-soft)',
  'var(--surface-muted)',
  'var(--surface-alt)',
  'var(--surface-base)',
] as const;

export function StatsGridBlock({ items, title }: StatsGridBlockProps) {
  if (!items.length && !title) return null;

  return (
    <Container size="xl" py={{ base: 52, md: 80 }}>
      <Stack gap={24}>
        {title ? (
          <Title
            order={2}
            style={{
              color: 'var(--text-primary)',
              fontWeight: 600,
              lineHeight: 1.35,
              letterSpacing: '-0.01em',
              fontSize: 'clamp(1.95rem, 3.6vw, 2.45rem)',
              maxWidth: 760,
            }}
          >
            {title}
          </Title>
        ) : null}

        {items.length ? (
          <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing={20}>
            {items.map((item, index) => (
              <Paper
                key={`${item.label}-${index}`}
                p={24}
                radius={40}
                withBorder
                style={{
                  background: statSurfaceCycle[index % statSurfaceCycle.length],
                  borderColor: 'var(--surface-border)',
                  borderWidth: 1.5,
                }}
              >
                <Stack gap={8}>
                  <Text style={{ color: 'var(--text-primary)', fontSize: 'clamp(2rem, 3.6vw, 2.55rem)', fontWeight: 600, lineHeight: 1.25, letterSpacing: '-0.01em' }}>
                    {item.value}
                  </Text>
                  <Text fw={600} size="sm" style={{ color: 'var(--text-primary)' }}>
                    {item.label}
                  </Text>
                  {item.description ? (
                    <Text size="sm" style={{ color: 'var(--text-secondary)', lineHeight: 1.65 }}>
                      {item.description}
                    </Text>
                  ) : null}
                </Stack>
              </Paper>
            ))}
          </SimpleGrid>
        ) : null}
      </Stack>
    </Container>
  );
}
